import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";
import { IPoliciesListSearch } from "../../types/IPoliciesListSearch";

export const searchPoliciesRoute = (searchParams: IPoliciesListSearch<string>) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", "search"].join("/"),
    searchParams: { ...searchParams },
  });
};

export const searchPolicyIdRoute = (policyId: number) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", policyId].join("/"),
  });
};

export const fetchPolicyVersionsRoute = (policyId: number) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", policyId, "versions"].join("/"),
  });
};

export const getPoliciesDicRoute = (dictType: string) =>
  buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dictType}` });

export const createPolicyRoute = () => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies"].join("/"),
  });
};

export const fetchOfferByIdRoute = (params: { id: number; onDate: string }) => {
  const { id, onDate } = params;
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering", id].join("/"),
    searchParams: {
      onDate,
    },
  });
};

export const updatePolicyRoute = ({
  policyId,
  params,
}: {
  policyId: number;
  params: { fromDate?: string; force: boolean };
}) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", policyId].join("/"),
    searchParams: {
      ...params,
    },
  });
};

export const updateCloseDatePolicyRoute = (params: { policyId: number; onDate?: string }) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", params.policyId].join("/"),
    searchParams: {
      onDate: params?.onDate,
    },
  });
};
